const models = Array.from({ length: 14 }).map((_, index: number) => ({
  label: `Modelo ${index + 1}`,
  value: `Modelo ${index + 1}`,
  index,
}));

const bases = [
  {
    label: 'Nenhum',
    value: 0,
  },
  {
    label: 'Nasal',
    value: 1,
  },
  {
    label: 'Superior',
    value: 2,
  },
  {
    label: 'Inferior',
    value: 3,
  },
  {
    label: 'Temporal',
    value: 4,
  },
].sort((a, b) => a.label.localeCompare(b.label));

const eye = [
  {
    label: 'Esquerdo',
    value: 0,
  },
  {
    label: 'Direito',
    value: 1,
  },
  {
    label: 'Ambos',
    value: 2,
  },
];

export { bases, eye, models };
